
import { Api } from '@/util/api';
import Vue from 'vue';
import ProductShelf from './product-list/ProductShelf.vue';

export default Vue.extend({
    name: 'AlternativeProducts',
    components: {
        'product-shelf': ProductShelf
    },
    props: {
        productKey: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: false,
            default: 3
        }
    },
    data() {
        return <{
            productKeys: string[] | null
        }> {
            productKeys: null
        };
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.refreshAlternativeProducts();
        },
        
        refreshAlternativeProducts() {
            Api.getInstance().getAlternativeProductKeys(this.productKey, this.amount)
                .then(productKeys => {
                    this.productKeys = productKeys.slice(0, this.amount);
                });
        }
    }
});
